import React, { useCallback, useEffect, useRef, useState } from "react";
import { Tooltip } from "@shopify/polaris";

export function TruncatedText({ children }: { readonly children: React.ReactNode }): React.ReactElement {
  const [tooltipContent, setTooltipContent] = useState("");
  const activator = useRef<HTMLSpanElement>(null);

  useEffect(() => {
    if (tooltipContent) {
      // Polaris makes its activator tabbable after rendering.
      activator.current.tabIndex = -1;
    }
  });

  const handleMouseEnter = useCallback((event: React.MouseEvent<HTMLSpanElement>): void => {
    const textElement = event.currentTarget.querySelector<HTMLElement>(".Polaris-Text--truncate");
    setTooltipContent(textElement.scrollWidth > textElement.clientWidth ? textElement.innerText : "");
  }, []);

  const handleMouseLeave = useCallback((): void => {
    setTooltipContent("");
  }, []);

  return (
    <span onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
      {tooltipContent ? (
        <Tooltip active content={tooltipContent} preferredPosition="above">
          <span ref={activator} tabIndex={-1}>
            {children}
          </span>
        </Tooltip>
      ) : (
        children
      )}
    </span>
  );
}
